import { es } from './es';
import { pt } from './pt';

export const schedulesLocale = {
  pt,
  es,
  'es-CR': {} as typeof es,
  'es-UY': {} as typeof es,
};
